function getThemeClassFromType(type) {
    switch (type.toLowerCase()) {
        case 'aps.download':
        case 'aps.license':
        case 'aps.licensewithvariants':
        case 'aps.licenseproductsectionoverviewpage':
            return 'croc';

        case 'aps.event':
        case 'aps.informationmeeting':
        case 'aps.customtraining':
        case 'aps.studytrip':
        case 'aps.webinar':
        case 'aps.training':
        case 'aps.trainingproductsectionoverviewpage':
            return 'panther';

        default:
            return 'megaman';
    }
}

export { getThemeClassFromType };
